module.exports = require("@getvim/components-hocs-with-intl");